import { BaseEntity } from "./BaseEntity";
import { TrainingYear } from "./TrainingYear";
import { Typology } from "./Typology";

export class Training extends BaseEntity {
    public name: string = "";
    public comment?: string | null = null;
    public trainingYears?: string[] | TrainingYear[] = [];
    public typologies?: string[] | Typology[] = [];

    constructor(model: Partial<Training> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PTraining = Partial<Training>;
